import React from 'react'
import Navbar from './containers/Navbar'

const Topbar = () => {
  return (
    <div>
      <Navbar />
      <div style={{ backgroundColor: '#eeeeee', height: '30pt' }}></div>
    </div>
  )
}

export default Topbar
